import Apps from './apps.js';
import Contacts from './contacts.js';
import Messages from './messages.js';
import Performance from './performance.js';
import Resources from './resources.js';
import Revenue from './revenue.js';
import Settings from './settings.js';

var NavigationIcon = {
  Apps: Apps,
  Contacts: Contacts,
  Messages: Messages,
  Performance: Performance,
  Resources: Resources,
  Revenue: Revenue,
  Settings: Settings
};

export { NavigationIcon as default };
//# sourceMappingURL=index.js.map
